import React, { useState } from "react";
import "./Post.scss";

const Post = (props) => {
  const [like, setLike] = useState(false);

  return (
    <div className="post-div">
      <div className="post">
        <div className="post-user">
          <div className="post-avatar-name">
            <div className="post-user-avatar">
              <i className="fas fa-universal-access" aria-hidden="true"></i>
            </div>
            <div className="post-user-info">
              <div className="post-user-name">{props.name}</div>
              <div className="post-user-date">{props.time}</div>
            </div>
          </div>
          <div className="post-user-opt">
            <i className="fas fa-ellipsis-h"></i>
          </div>
        </div>
        <div className="post-content">
          <p>{props.content}</p>
        </div>
        <div className="post-img">
          <img alt="" src={props.url} />
        </div>
        <div className="post-likes">
          <div className="post-likes-emojis">
            <i className="fas fa-thumbs-up"></i>
            <i className="fas fa-heart"></i>
            <span>{like ? "3" : "2"}</span>
          </div>
          <div className="post-likes-comments">
            <span>1 comentario</span>
          </div>
        </div>
        <div className="post-buttons">
          <div
            className="post-buttons-btn"
            onClick={() => setLike(!like)}
            className={like ? "post-buttons-btn-like" : "post-buttons-btn"}
          >
            <i className="far fa-thumbs-up"></i>
            <span>Me Gusta</span>
          </div>
          <div className="post-buttons-btn">
            <i className="far fa-comment"></i>
            <span>Comentar</span>
          </div>
          <div className="post-buttons-btn">
            <i className="far fa-share-square"></i>
            <span>Compartir</span>
          </div>
        </div>
        <div className="post-comment">
          <div className="post-comment-see">
            <span>Ver comentarios</span>
          </div>
          <div className="post-comment-user">
            <div className="post-comment-avatar">
              <i className="fas fa-universal-access" aria-hidden="true"></i>
            </div>
            <div className="post-comment-comment">
              <input placeholder="Escribe un comentario" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Post;
